// extracted by mini-css-extract-plugin
export default {"overlay":"Dialog_overlay__l3pFO","fadeIn":"Dialog_fadeIn__6Frb5","holder":"Dialog_holder__6UFC3"};